import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { defaultLocale, isLocale, resources, type Locale, type de } from '@ticketai/i18n';

declare module 'i18next' {
  interface CustomTypeOptions {
    defaultNS: 'translation';
    resources: { translation: typeof de };
  }
}

const STORAGE_KEY = 'ticketai.locale';

function storedLocale(): Locale {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return isLocale(value) ? value : defaultLocale;
  } catch {
    return defaultLocale;
  }
}

void i18n.use(initReactI18next).init({
  resources,
  lng: storedLocale(),
  fallbackLng: defaultLocale,
  // React escapes output already.
  interpolation: { escapeValue: false }
});
document.documentElement.lang = i18n.language;

/** Switches the UI language and remembers it in this browser. */
export function setLocale(locale: Locale) {
  void i18n.changeLanguage(locale);
  document.documentElement.lang = locale;
  try {
    localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    // Storage blocked: the choice lasts for this tab only.
  }
}

export { i18n };
